// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__IBMPlexSansSemiBold_a794a1', '__IBMPlexSansSemiBold_Fallback_a794a1'","fontWeight":600},"className":"__className_a794a1","variable":"__variable_a794a1"};